import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Products, Product, CreateProduct, UpdateProduct } from "./pages";

export const ProductsRouter = [
  <Route
    path="/products"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Products />
      </ProtectedRoute>
    }
  />,

  <Route path="/product">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateProduct />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Product />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateProduct />
        </ProtectedRoute>
      }
    />
  </Route>,
];
